export default "__VITE_ASSET__WNR0h87L__"